import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=42d930e3&scoped=true&"
import script from "./RecordTable.vue?vue&type=script&lang=js&"
export * from "./RecordTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordTable.vue?vue&type=style&index=0&id=42d930e3&prod&lang=scss&scoped=true&"
import style1 from "./RecordTable.vue?vue&type=style&index=1&id=42d930e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d930e3",
  null
  
)

export default component.exports